import { SvgIcon, SvgIconProps } from '@mui/material';

const StripeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Stripe">
          <g id="Vector">
            <path
              d="M1.43597 3.18404C1 4.03969 1 5.15979 1 7.4V8.6C1 10.8402 1 11.9603 1.43597 12.816C1.81947 13.5686 2.43139 14.1805 3.18404 14.564C4.03969 15 5.15979 15 7.4 15H8.6C10.8402 15 11.9603 15 12.816 14.564C13.5686 14.1805 14.1805 13.5686 14.564 12.816C15 11.9603 15 10.8402 15 8.6V7.4C15 5.15979 15 4.03969 14.564 3.18404C14.1805 2.43139 13.5686 1.81947 12.816 1.43597C11.9603 1 10.8402 1 8.6 1H7.4C5.15979 1 4.03969 1 3.18404 1.43597C2.43139 1.81947 1.81947 2.43139 1.43597 3.18404Z"
              fill="url(#paint0_linear_8734_31856)"
            />
            <path
              d="M1.13261 4.13976C1 4.8934 1 5.89341 1 7.4V8.6C1 10.8402 1 11.9603 1.43597 12.816C1.81947 13.5686 2.43139 14.1805 3.18404 14.564C4.03969 15 5.15979 15 7.4 15H8.6C10.8402 15 11.9603 15 12.816 14.564C13.5686 14.1805 14.1805 13.5686 14.564 12.816C15 11.9603 15 10.8402 15 8.6V7.4C15 5.15979 15 4.03969 14.564 3.18404C14.1939 2.45758 13.6109 1.8622 12.894 1.47681L1.13261 4.13976Z"
              fill="url(#paint1_linear_8734_31856)"
            />
            <path
              d="M14.8552 11.927C14.7909 12.2649 14.698 12.5529 14.564 12.816C14.1805 13.5686 13.5686 14.1805 12.816 14.564C11.9859 14.987 10.907 14.9996 8.79813 15H8.0293V13.4184L14.8552 11.927Z"
              fill="url(#paint2_linear_8734_31856)"
            />
            <path
              d="M8.6 1H7.4C6.96417 1 6.57074 1 6.21339 1.00321V2.98526L12.8927 1.47613C12.8673 1.46248 12.8417 1.44909 12.816 1.43597C12.3409 1.19394 11.7844 1.08627 11 1.03838C10.3714 1 9.59655 1 8.6 1Z"
              fill="url(#paint3_linear_8734_31856)"
            />
            <path
              d="M15 8.68668C14.9999 10.1895 14.9973 11.18 14.8552 11.927L12.4812 12.4457V8.90792L15 8.32214V8.68668Z"
              fill="url(#paint4_linear_8734_31856)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.47046 6.68895C7.47046 6.36761 7.73318 6.24402 8.16831 6.24402C8.79228 6.24402 9.58044 6.43352 10.2044 6.77134V4.83507C9.52297 4.56317 8.84975 4.45605 8.16831 4.45605C6.50167 4.45605 5.39331 5.32944 5.39331 6.78782C5.39331 9.06191 8.51313 8.69938 8.51313 9.67987C8.51313 10.0589 8.18473 10.1825 7.72497 10.1825C7.04353 10.1825 6.17327 9.90234 5.48362 9.52332V11.4843C6.24716 11.8139 7.0189 11.954 7.72497 11.954C9.43266 11.954 10.6067 11.1053 10.6067 9.63043C10.5985 7.17508 7.47046 7.61177 7.47046 6.68895Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_8734_31856"
            x1="1"
            y1="1"
            x2="5.59833"
            y2="4.25105"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#392993" />
            <stop offset="1" stopColor="#4B47B9" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_8734_31856"
            x1="1.5272"
            y1="3.9095"
            x2="11.9612"
            y2="12.223"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#594BB9" />
            <stop offset="1" stopColor="#60A8F2" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_8734_31856"
            x1="1"
            y1="8.06148"
            x2="15.836"
            y2="9.52078"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#61A2EF" />
            <stop offset="1" stopColor="#58E6FD" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_8734_31856"
            x1="1"
            y1="8.02247"
            x2="19.6324"
            y2="7.39483"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#534EBE" />
            <stop offset="1" stopColor="#6875E2" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_8734_31856"
            x1="1"
            y1="3.08822"
            x2="8.03539"
            y2="16.8825"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#71A5F3" />
            <stop offset="1" stopColor="#6CC3FA" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default StripeIcon;
